import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import config from 'config/api'
import { Link } from 'react-router-dom';
import './Mission.css';
import IconArrow from '@material-ui/icons/ArrowLeft';
import ScrollToTopOnMount from '../ScrollToTopOnMount';

// import Immutable from 'immutable';

import {
  fetchData,
  getDataMissions,
  getLoadingError,
} from '../../ducks/asyncFetcher';

import {
  isLoggedIn,
} from '../../ducks/authentication';

const AF_KEY = 'missions';

class Mission extends Component {
  constructor(props) {
    super(props);
    this.$left = false;
    this.$right = false;
  }
  componentDidMount() {

    this.props.onMount(this.props.missionId, this.props.ficheId);

    // this._resize = this._resize.bind(this);
    window.addEventListener('resize', this._resize);
  }
  compoentnWillUnmount() {
    console.log('CLEANING UP!!')
    window.removeEventListener('resize')
  }
  componentDidUpdate(oldProps) {
    // if (oldProps.missionId !== undefined && oldProps.missionId !== this.props.missionId)
    if (oldProps.missionId !== this.props.missionId)
    this.props.onMount(this.props.missionId);

    if (oldProps.$$data === undefined && this.props.$$data !== undefined)
    this._resize();

  }
  _resize() {
    if (!this.$left || !this.$right) return;

    const maxHeight = window.innerHeight;
    console.log(this.$left, maxHeight)
    if (this.$left.offsetHeight < maxHeight) {
      console.log('too small !')
      this.$left.height = maxHeight;
    }
    if (this.$right.height < maxHeight)
    this.$right.height = maxHeight;
  }

  render() {

    const { missionId, $$data, isLoggedIn } = this.props;

    if (!isLoggedIn) {
      return <Redirect to={{
          pathname: '/',
          state: { from: this.props.location }
        }}/>
      }

      return (
        <div id="missions" className="MissionsIndex">
          <Choose>
            <When condition={$$data !== undefined}>
              <ScrollToTopOnMount/>
              <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" className={'wrapper'}>
                <Grid item xs={12} sm={4} className="menu" ref={(r) => this.$left = r}>
                  <If condition={$$data.get('missions') !==undefined && $$data.get('missions').get('logo')}>
                    <img src={$$data.get('missions').get('logo')} alt="" width="80%"/>
                  </If>
                  <h3>Liste des missions associées <span className="count">{$$data.get('missions') !==undefined && $$data.get('missions').get('index').size}</span></h3>
                  <ul>
                    <If condition={$$data.get('missions').get('index') !==undefined}>
                      {$$data.get('missions').get('index').map((mission, i) => {
                        return <li key={'mission_'+i} className={(mission.get('id') === missionId ? 'sel' : '')}>
                          <Link to={'/mission/'+mission.get('id')} ><span className="code">{mission.get('code_mission')}</span>
                          <If condition={mission.get('type_poste')}>
                            : <span className="profil" >{mission.get('type_poste')}</span>
                        </If>
                      </Link>
                    </li>
                  }).toArray()}
                </If>
              </ul>
            </Grid>
            <Grid item xs={12} sm={8} className="content" ref={(r) => this.$right = r}>
              <ul>
                <If condition={$$data.get('missions').get('details') !==null}>
                  {$$data.get('missions').get('details').map((item, i) => {
                    return <li key={'item'+i}>
                      <span className="code pure-u-1">Label N°{item.get('code_candidat')}</span>
                      <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start">
                        <Grid item xs={12} sm={6} className="left">
                          <span className="title">{item.get('prenom')} {item.get('nom')}</span>
                        </Grid>
                        <Grid item xs={12} sm={6} className="right">
                          <Link to={'/mission/'+missionId+'/fiche/'+item.get('id')} className="button">Consulter la fiche</Link>
                        </Grid>
                      </Grid>
                    </li>
                  }).toArray()};
                </If>
                <If condition={$$data.get('missions').get('details') ===null}>
                  <li className="noMission"><IconArrow style={{verticalAlign: 'middle', marginTop: '-2px'}}/> Veuillez selectionner une mission dans la liste</li>
                </If>
              </ul>
            </Grid>
          </Grid>
        </When>
        <Otherwise>
          <div>LOADING !!</div>
        </Otherwise>
      </Choose>
    </div>

  );
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataMissions(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: (missionId) => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.missions.replace(':missionId', missionId || '')}))},
  };
}
// export default Mission;
export default connect(mapStateToProps, mapDispatchToProps)(Mission);



// WEBPACK FOOTER //
// ./src/components/Mission/Mission.jsx